import { useLingui } from '@lingui/react/macro'
import { useParams } from 'next/navigation'

import { PoweredBy } from '../powered-by'
import { AnswerCard } from './answer-card'

export const SchedulingAnswerPageContent = ({
	idOrSlug,
	embedded = false,
	successPath,
}: {
	idOrSlug: string
	embedded?: boolean
	successPath?: string
}) => {
	const { t } = useLingui()

	return (
		<div className='flex min-h-screen flex-1 flex-col items-center justify-center gap-4 max-md:pt-8 max-md:pb-[60px]'>
			<div className='flex flex-col items-center gap-2'>
				{!embedded && <div className='mb-4 text-3xl font-bold'>{t`Je prends rendez-vous`}</div>}

				<AnswerCard
					idOrSlug={idOrSlug}
					successPath={successPath}
				/>
				<PoweredBy />
			</div>
		</div>
	)
}

export const SchedulingAnswerPage = () => {
	const { slugOrId } = useParams<{ slugOrId: string }>()

	return <SchedulingAnswerPageContent idOrSlug={slugOrId} />
}
